export const VALUE_DRIVER = "@driver/VALUE_DRIVER";
export const DOCUMENTS_NOTIFICATION = "@driver/DOCUMENTS_NOTIFICATION";

export type VALUE = typeof VALUE_DRIVER;

export interface SetValueDriver {
  type: VALUE;
  payload: {
    valueDriver: null;
  };
}

export function setValueDriver(valueDriver: any): SetValueDriver {
  return {
    type: VALUE_DRIVER,
    payload: {
      valueDriver: valueDriver,
    },
  };
}

export function setDocumentsNotification(message: string): {
  type: typeof DOCUMENTS_NOTIFICATION;
  payload: {
    notificationMessage: string;
  };
} {
  return {
    type: DOCUMENTS_NOTIFICATION,
    payload: {
      notificationMessage: message,
    },
  };
}
